import React, {FunctionComponent, useCallback, useContext} from 'react';
import {WisetackContext} from "../../context/WisetackContext";
import {Wisetack} from "../../models/wisetack.model";
import "./WisetackLearnMoreDialog.scss";
import {FullScreenModal} from "../Modal/FullScreenModal";
import closeIcon from "../../assets/icons/times-solid.svg";
import {Button} from "../ui-components/Button/Button";
import WisetackLogo from "../../assets/images/wisetack-logo.svg";


interface WisetackLearnMoreDialogProps {
    onCloseDialog: () => void;
}

export const WisetackLearnMoreDialog: FunctionComponent<WisetackLearnMoreDialogProps> = (props) => {
    const wisetack: Wisetack | null = useContext(WisetackContext).wisetack;

    const onCloseWisetackLearnMore = useCallback(() => {
        props.onCloseDialog();
    }, [props.onCloseDialog]);

    return (
        <FullScreenModal>
            <div>
                <>
                    <header>
                        <h1>&nbsp;</h1>

                        <img onClick={onCloseWisetackLearnMore} className='image-icon desktop-2x clickable' src={closeIcon}
                             alt="close"/>
                    </header>

                    <main className='wisetack-modal'>
                        <div><img className="wisetack-logo" src={WisetackLogo}/></div>

                        <h3 className="wisetack-headline">{wisetack?.headline}</h3>

                        <p className="wisetack-tagline">{wisetack?.tagline}</p>

                        <ul className="wisetack-offer">
                            <li>{wisetack?.valueProp1}</li>
                            <li>{wisetack?.valueProp2}</li>
                            <li>{wisetack?.valueProp3}</li>
                        </ul>

                        <p className="wisetack-disclosure">{wisetack?.disclosure}</p>
                    </main>

                    <footer>
                        <Button className='secondary-button' onClick={onCloseWisetackLearnMore}
                                type={'button'}>Close</Button>
                        <a target="_blank" href={wisetack?.link}><Button>See Loan Options</Button></a>
                    </footer>
                </>
            </div>
        </FullScreenModal>
    );
};
